import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios'
import { Link } from 'react-router-dom';
import MultiDeviceSelector from './MultiDeviceSelector';

// Compare deux versions "MAJOR.MINOR.PATCH" -> true si v >= target. Version inconnue/vide = "0" (< tout).
const versionGte = (v, target) => {
    const pa = String(v || '0').split('.').map((n) => parseInt(n, 10) || 0);
    const pb = String(target).split('.').map((n) => parseInt(n, 10) || 0);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const a = pa[i] || 0, b = pb[i] || 0;
        if (a !== b) return a > b;
    }
    return true; // égales
};

const ModalModifyTizenbo = ({ isVisible, onClose, choosenClientBo, devices }) => {

    let token = localStorage.getItem('token')
    //let token = keycloak.token;

    const [values, setValues] = useState({
        _mac_eth: '',
        _tizen_id: '',
        _pin_code: '',
        _client_name: '',
        _app_type: '',
        _authorized: '',
        _video_url: '',
        _video_url_2: '',
        _video_url_3: '',
        _video_code: '',
        _video_code_2: '',
        _video_code_3: '',
        _end_date: '',
        id: '',
        _app_version: '',
        _zoom: '',
        _display_id: '',
        _client_id: '',
        _room_id: ' ',
        _id_pdv: '',
        _limite_notif: 0,
        _screen_id: '',
        _clients_synchro: [],
        _unused_videos: 0,

    });
    const [idClientAnnuaire, setIdClientAnnuaire] = useState('');


    const [datas, setDate] = useState([]);
    const [clients, setClients] = useState([]);
    const [clientsVideoWall, setClientsVideoWall] = useState([]);

    const [search, setSearch] = useState('');
    const [searchPriceEat, setSearchPriceEat] = useState('');
    // Feedback "copié !" du bouton PIN (retombe tout seul après 1,5 s).
    const [pinCopied, setPinCopied] = useState(false);
    const copyPin = () => {
        const pin = String(values._pin_code || '').trim();
        if (!pin) return;
        const done = () => { setPinCopied(true); setTimeout(() => setPinCopied(false), 1500); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(pin).then(done).catch(() => {});
        } else {
            // Fallback vieux navigateurs / contexte non sécurisé.
            const ta = document.createElement('textarea');
            ta.value = pin; document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); done(); } catch (e) { /* noop */ }
            document.body.removeChild(ta);
        }
    };
    // Recherche Call-Eat (remplissage assisté du Room ID, même pattern que le PriceEat).
    const [calleats, setCalleats] = useState([]);
    const [searchCallEat, setSearchCallEat] = useState('');

    const [videoKeys, setVideoKey] = useState('')

    //? Variable Pagination 
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    const lastIndex = currentPage * recordsPerPage;
    const firstindex = lastIndex - recordsPerPage
    // const records = datas.slice(firstindex, lastIndex)
    const npage = Math.ceil(datas.length / recordsPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)
    const [isSelectorVisible, setIsSelectorVisible] = useState(false);

    const [currentClientLinks, setCurrentClientLinks] = useState([]);

    useEffect(() => {
    const handleKeyDown = (event) => {
        // Vérifie si la touche pressée est "Escape" et si la modal est visible
        if (event.key === 'Escape' && isVisible) {
            onClose();
        }
    };

    // On attache l'événement au document
    document.addEventListener('keydown', handleKeyDown);

    // Nettoyage de l'événement quand le composant est démonté
    return () => {
        document.removeEventListener('keydown', handleKeyDown);
    };
}, [isVisible, onClose]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/listVideos`)
            .then(res => {
                setDate(res.data.files.filter((auth) => auth.fileName.endsWith('.mp4')))
            })
            .catch(err => console.log(err))

        const headers = {
            'x-access-token': token,
            'Content-Type': 'application/json'
        };
        const data = {
            token: token
        };

        axios.post(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/admin/auth/listeUsers`, data, { headers })
            .then(res => {
                //console.log(res.data);
                setClients(res.data)
            }).catch(err => console.log(err))


        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_clients_videowall`)
            .then(resVw => {
                console.log(resVw.data);
                setClientsVideoWall(resVw.data)
            }).catch(errVw => console.log(errVw))

        // Clients Call-Eat (recherche Room ID).
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_client_calleat`)
            .then(res => setCalleats(res.data || []))
            .catch(err => console.log(err))
    }, [])

    useEffect(() => {
        if (isVisible && values._pin_code) {
            // Filtre la liste globale pour trouver les clients de ce serveur
            const clients = clientsVideoWall.filter(link => link.pin_code_serveur === values._pin_code);
            setCurrentClientLinks(clients);
        }
    }, [isVisible, values._pin_code, clientsVideoWall])

    const handleRemoveExistingClient = (id_videowall) => {
        // 1. Demande de confirmation
        // if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette liaison client ?")) {
        //     return;
        // }

        // 2. Appel à l'API (que vous devez créer)
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_client_videowall/${id_videowall}`, { headers })
            .then(res => {
                console.log("Liaison supprimée:", res.data);

                // 3. Mise à jour de l'interface SANS recharger la page
                setCurrentClientLinks(prevLinks =>
                    prevLinks.filter(link => link.id_videowall !== id_videowall)
                );
                setClientsVideoWall(prevList =>
                    prevList.filter(link => link.id_videowall !== id_videowall)
                );
            })
            .catch(err => {
                // ... (gestion d'erreur)
            });
    };

    const handleCodePins = (selectedPins) => {
        console.log("PINs sélectionnés :", selectedPins);

        // Stocke les pin codes dans l'état 'values'
        setValues(prevValues => ({
            ...prevValues,
            _clients_synchro: selectedPins
        }));

        setIsSelectorVisible(false); // Ferme le sélecteur
    };

    useEffect(() => {
        if (!devices || !choosenClientBo._pin_code) return;

        const match = devices.find(device => device._pin_code === choosenClientBo._pin_code);

        if (match && match.id_client) {
            setIdClientAnnuaire(match.id_client);
        } else {
            setIdClientAnnuaire('');
        }
    }, [devices, choosenClientBo._pin_code])


    let data = {
        _mac_eth: '',
        _tizen_id: '',
        _pin_code: '',
        id: '',
    }

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    function formatDateTizen(input) {
        var datePart = String(input ?? '').match(/\d+/g);
        // Champ vide ou invalide -> pas de crash : on repousse d'un an par défaut.
        if (!datePart || datePart.length < 3) {
            const d = new Date();
            d.setFullYear(d.getFullYear() + 1);
            return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} 23:59:59`;
        }
        var year = datePart[0], month = datePart[1], day = datePart[2];
        return year + '/' + month + '/' + day + ' ' + '23:59:59';
    }


    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // error.innerHTML = '';
        let dateToBack = formatDateTizen(values._end_date)
        values._end_date = dateToBack

        // axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDeviceV2`, { values }, { headers })
        axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDeviceV2`, { values })
            .then((data) => {
                // console.log(data);
                if (values._clients_synchro && values._clients_synchro.length > 0) {
                    let dataVw = {
                        nom: values._client_name,
                        pin_code_serveur: values._pin_code,
                        pin_code_client: values._clients_synchro,
                    }
                    return axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_clients_videowall`, { dataVw })
                }
                return null;
            }).then((dataVideoWall) => {
                if (dataVideoWall) {
                    console.log("Clients VideoWall ajoutés:", dataVideoWall.data);
                }
                // 3. Rechargement de la page (après toutes les opérations)
                window.location.reload(false);
            })
            .catch(err => {
                console.log("Erreur lors de l'enregistrement:", err)
                // Même en cas d'erreur, on peut recharger pour voir l'état actuel
                window.location.reload(false);
            })


    }

    // "Activer la gestion" : déclenche le provisionnement à distance (POST /provision_device ->
    // le back publie "provision" sur le topic MQTT = pincode -> la signage rootée bootstrappe le
    // provisioner). N'a besoin QUE du pincode ; indépendant de l'Annuaire.
    const handleProvision = () => {
        if (!values._pin_code) { alert('Pincode manquant sur ce device.'); return; }
        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/provision_device`, { _pin_code: values._pin_code }, { headers })
            .then(() => alert('Commande de provisionnement envoyée au device (' + values._pin_code + ').'))
            .catch((e) => { console.log(e); alert("Échec de l'envoi de la commande de provisionnement."); });
    };

    // "Récupérer logcat signage" : miroir de handleProvision. POST /request_logcat -> le back publie
    // "logcat" sur le topic MQTT = pincode -> la signage dumpe les 3 dernières minutes de logcat et
    // les remonte sur n8n. Bouton visible uniquement pour les devices >= 5.3.3 (commande ajoutée là).
    const handleRequestLogcat = () => {
        if (!values._pin_code) { alert('Pincode manquant sur ce device.'); return; }
        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/request_logcat`, { _pin_code: values._pin_code }, { headers })
            .then(() => alert('Commande « Récupérer logcat » envoyée au device (' + values._pin_code + '). Le logcat des 3 dernières minutes va remonter sur n8n.'))
            .catch((e) => { console.log(e); alert("Échec de l'envoi de la commande de récupération du logcat."); });
    };

    const deleteArticle = (e) => {
        data._mac_eth = values._mac_eth
        data._tizen_id = values._tizen_id
        data._pin_code = values._pin_code
        data.id = values.id

        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/DeleteInterfaceTizenDeviceV2`, { headers, data })
            .then((data) => {
                // console.log(data);
                window.location.reload(false);
            }).catch(err => console.log(err))
    }

    const close = () => {
        let divTooltip = document.getElementById('popup-12');
        divTooltip.style.display = "none"
    }

    //if (choosenClientBo.id !== values.id) setValues({ ...values, ...choosenClientBo })

    if (choosenClientBo.id !== values.id) {
        // Assure que _clients_synchro est initialisé comme un tableau même si choosenClientBo ne l'a pas
        const initialSynchro = choosenClientBo._clients_synchro || [];
        setValues({ ...values, ...choosenClientBo, _clients_synchro: initialSynchro });
    }

    function formatDateClient(datePose) {
        let newdate = new Date(datePose)
        // let month = newdate.getMonth()+1
        let month = newdate.getMonth() + 1 > 9 ? newdate.getMonth() + 1 : `0${newdate.getMonth() + 1}`
        let day = newdate.getDate() > 9 ? newdate.getDate() : `0${newdate.getDate()}`
        let formatDate = `${newdate.getFullYear()}-${month}-${day}`
        return formatDate;
    }

    /**
     * Valeur SÛRE pour <input type="date"> : rend la date saisissable au clavier ET sélectionnable
     * au calendrier. L'ancien `value={formatDateClient(...)}` repassait CHAQUE frappe par
     * `new Date()` -> saisie partielle = Invalid Date = "NaN-NaN-NaN" -> le champ se vidait.
     * Ici : si la valeur est déjà au format ISO (venant de l'input), on la renvoie telle quelle ;
     * sinon (valeur venant de la base, ex. "2026/07/12 23:59:59") on la convertit une seule fois.
     */
    function dateInputValue(v) {
        const s = String(v ?? '');
        if (!s) return '';
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10); // déjà ISO (saisie clavier/calendrier)
        const d = new Date(s);
        return Number.isNaN(d.getTime()) ? '' : formatDateClient(s);
    }



    const dropdownVideo = (idDrop, vidoeKey) => (e) => {
        e.preventDefault();
        setVideoKey(vidoeKey)
        let element = document.getElementById(idDrop);
        if (element.style.display === "block") {
            element.style.display = "none"
        } else {
            element.style.display = "block"
        }
    }

    const setClientPdv = (clientIdTemp, idPdvTemp) => (e) => {
        e.preventDefault();
        let element = document.getElementById('dropdownPriceEat')
        console.log(clientIdTemp);
        setValues({ ...values, _client_id: clientIdTemp, _id_pdv: idPdvTemp })
        // setValues({...values, _id_pdv: idPdvTemp})
        element.style.display = "none"

    }

    // Sélection d'un client Call-Eat -> remplit le Room ID du device.
    const setCallEatRoom = (roomIdTemp) => (e) => {
        e.preventDefault();
        setValues({ ...values, _room_id: roomIdTemp })
        const element = document.getElementById('dropdownCallEat')
        if (element) element.style.display = "none"
    }
    const setVideoUrl = (urlVideo) => (e) => {
        e.preventDefault();

        let element = document.getElementById('dropdown1');
        switch (videoKeys) {
            case '_video_url':
                setValues({ ...values, _video_url: urlVideo });
                element.style.display = "none"
                break;
            case '_video_url_2':
                setValues({ ...values, _video_url_2: urlVideo });
                element.style.display = "none"
                break;
            case '_video_url_3':
                setValues({ ...values, _video_url_3: urlVideo });
                element.style.display = "none"
                break;
            default:
                break;
        }
    }

    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        if (newRole !== '1') {
            // Si le nouveau rôle n'est PAS Serveur (1),
            // on vide la liste des clients à ajouter pour éviter les erreurs.
            setValues({
                ...values,
                _video_code_2: newRole,
                _clients_synchro: [] // Vider le tableau !
            });
        } else {
            // Sinon, on met juste à jour le rôle
            setValues({ ...values, _video_code_2: newRole });
        }
    };

    function greaterThanZero(value) {
        if (value < 10) {
            return `0${value}`
        } else {
            return value
        }
    }

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCurrPage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }

    // **** DÉBUT DE LA NOUVELLE LOGIQUE ****
    // On calcule les relations existantes avant le 'return'

    // 1. Récupérer le PIN de l'appareil en cours d'édition
    const currentPin = values._pin_code;

    // 2. CAS 1: Vérifier si cet appareil est un SERVEUR
    // On filtre 'clientsVideoWall' pour trouver toutes les entrées où 'currentPin' est le serveur
    const clientPinsForThisServer = clientsVideoWall
        .filter(link => link.pin_code_serveur === currentPin)
        .map(link => link.pin_code_client); // On ne garde que les PINs clients

    // 3. CAS 2: Vérifier si cet appareil est un CLIENT
    // On cherche dans 'clientsVideoWall' une entrée où 'currentPin' est le client
    const serverForThisClient = clientsVideoWall.find(link => link.pin_code_client === currentPin);

    // **** FIN DE LA NOUVELLE LOGIQUE ****

    // Statut "Télémaintenance" : lu DIRECTEMENT sur la ligne écran (t_model_v1 via
    // InterfaceTizenDevice) -> id_rustdesk / id_anydesk présents + fraîcheur provisioned_at.
    // Source unique : /record_provisioning écrit ces mêmes champs sur t_model_v1 (matché par pincode).
    const _hasRd = !!(values.id_rustdesk && String(values.id_rustdesk).trim());
    const _hasAd = !!(values.id_anydesk && String(values.id_anydesk).trim());
    const _prov = values.provisioned_at ? new Date(values.provisioned_at) : null;
    const _provDays = _prov && !isNaN(_prov.getTime()) ? Math.floor((Date.now() - _prov.getTime()) / 86400000) : null;
    let telemColor = 'bg-red-500', telemLabel = 'Non géré';
    if (_hasRd && _hasAd && _provDays !== null && _provDays <= 30) { telemColor = 'bg-emerald-500'; telemLabel = 'Géré'; }
    else if (_hasRd || _hasAd || _provDays !== null) { telemColor = 'bg-amber-500'; telemLabel = 'Partiel'; }

    if (!isVisible) return null;
    return (
        <>
            <div className='fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center p-4' id="wrapper" onClick={handleClose}>
                <div className='w-2/3 max-w-4xl flex flex-col'>
                    {/* <div className='flex justify-between'> */}
                    <div className='w-full'>
                        <div id="dropdown1" class="z-40 hidden absolute top-8 bg-white divide-y rounded-lg shadow w-2/3 h-3/4 dark:bg-slate-700 cursor-pointer overflow-auto">
                            <div className="relative flex items-center left-1/4 w-2/4 h-10 rounded-lg border border-slate-300 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/30 bg-white overflow-hidden my-2">
                                <div className="grid place-items-center h-full w-12 text-slate-400">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>

                                <input
                                    className="h-full w-full outline-none text-sm text-slate-800 pr-2 bg-white placeholder-slate-400"
                                    type="text"
                                    id="search"
                                    placeholder="Search something.."
                                    onChange={(e) => { setSearch(e.target.value); setCurrentPage(1) }}
                                />
                            </div>
                            <table class="w-full text-sm text-left text-slate-500 dark:text-slate-400">
                                <thead class="text-xs text-slate-700 uppercase bg-slate-50 dark:bg-slate-700 dark:text-slate-400">
                                    <tr>
                                        <th scope="col" class="px-6 py-3">
                                            File Name
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            File Date
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            File Size
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {


                                        datas.filter((item) => {
                                            return search.toLowerCase() === ''
                                                ? item
                                                : item.fileName.toLowerCase().includes(search.toLowerCase())
                                        }).slice(firstindex, lastIndex).map((video, i) => (
                                            <tr class="bg-white border-b dark:bg-slate-800 dark:border-slate-700" key={i} onClick={setVideoUrl(process.env.REACT_APP_DL_IP + 'MOV/' + video.fileName)} >
                                                <th scope="row" class="px-6 py-4 font-medium text-slate-900 whitespace-nowrap dark:text-white">
                                                    {video.fileName}
                                                </th>
                                                <td class="px-6 py-4">
                                                    {greaterThanZero(new Date(video.fileDate).getUTCDate())}/{greaterThanZero(new Date(video.fileDate).getUTCMonth())}/{greaterThanZero(new Date(video.fileDate).getUTCFullYear())}  {greaterThanZero(new Date(video.fileDate).getUTCHours() + 2)}:{greaterThanZero(new Date(video.fileDate).getUTCMinutes())}
                                                </td>
                                                <td class="px-6 py-4">
                                                    {video.fileSize}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example" className='absolute bottom-4 right-2/4'>
                                <ul className="inline-flex -space-x-px text-sm">
                                    <li>
                                        <a className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-slate-500 bg-white border border-slate-300 rounded-l-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={prePage} >Previous</a>
                                    </li>

                                    {numbers.map((n, i) => {
                                        return <li>
                                            <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={() => changeCurrPage(n)}>{n}</a>
                                        </li>
                                    })}

                                    <li>
                                        <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 rounded-r-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={nextPage} >Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        {/* Dropdown de recherche Call-Eat (même mécanique que dropdownPriceEat). */}
                        <div id="dropdownCallEat" className="z-40 hidden absolute top-8 bg-white divide-y rounded-lg shadow-xl border border-slate-200 w-2/3 h-3/4 cursor-pointer overflow-auto">
                            <div className="relative left-1/4 my-2 flex h-10 w-2/4 items-center overflow-hidden rounded-lg border border-slate-300 bg-white focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/30">
                                <div className="grid h-full w-12 place-items-center text-slate-400">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                <input
                                    className="h-full w-full bg-white pr-2 text-sm text-slate-800 placeholder-slate-400 outline-none"
                                    type="text"
                                    placeholder="Nom client ou room id…"
                                    onChange={(e) => setSearchCallEat(e.target.value)}
                                />
                            </div>
                            <table className="w-full text-left text-sm text-slate-500">
                                <thead className="bg-slate-50 text-xs uppercase text-slate-700">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">Nom client</th>
                                        <th scope="col" className="px-6 py-3">Room ID</th>
                                        <th scope="col" className="px-6 py-3">Autorisé</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {calleats.filter((c) => {
                                        const t = searchCallEat.toLowerCase();
                                        return t === ''
                                            ? true
                                            : String(c.nom_client || '').toLowerCase().includes(t) || String(c.room_id || '').toLowerCase().includes(t);
                                    }).map((c, i) => (
                                        <tr className="border-b bg-white hover:bg-indigo-50/40" key={i} onClick={setCallEatRoom(c.room_id)}>
                                            <th scope="row" className="whitespace-nowrap px-6 py-3 font-medium text-slate-900">{c.nom_client}</th>
                                            <td className="px-6 py-3">{c.room_id}</td>
                                            <td className="px-6 py-3">
                                                <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${c.autorised === 1 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                                                    {c.autorised === 1 ? 'Oui' : 'Non'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div id="dropdownPriceEat" class="z-40 hidden absolute top-8 bg-white divide-y rounded-lg shadow w-2/3 h-3/4 dark:bg-slate-700 cursor-pointer overflow-auto">
                            <div className="relative flex items-center left-1/4 w-2/4 h-10 rounded-lg border border-slate-300 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/30 bg-white overflow-hidden my-2">
                                <div className="grid place-items-center h-full w-12 text-slate-400">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>

                                <input
                                    className="h-full w-full outline-none text-sm text-slate-800 pr-2 bg-white placeholder-slate-400"
                                    type="text"
                                    id="search"
                                    placeholder="Search something.."
                                    onChange={(e) => { setSearchPriceEat(e.target.value); setCurrentPage(1) }}
                                />
                            </div>
                            <table class="w-full text-sm text-left text-slate-500 dark:text-slate-400">
                                <thead class="text-xs text-slate-700 uppercase bg-slate-50 dark:bg-slate-700 dark:text-slate-400">
                                    <tr>
                                        <th scope="col" class="px-6 py-3">
                                            Client ID
                                        </th>
                                        <th scope="col" class="px-6 py-3">
                                            ID PDV
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {


                                        clients.filter((item) => {
                                            return searchPriceEat.toLowerCase() === ''
                                                ? item
                                                : item.username.toLowerCase().includes(searchPriceEat.toLowerCase()) || item.id_pdv.toLowerCase().includes(searchPriceEat.toLowerCase())
                                        }).slice(firstindex, lastIndex).map((client, i) => (
                                            <tr class="bg-white border-b dark:bg-slate-800 dark:border-slate-700" key={i} onClick={setClientPdv(client.username, client.id_pdv)} >
                                                {/* <tr class="bg-white border-b dark:bg-slate-800 dark:border-slate-700" key={i} > */}
                                                <th scope="row" class="px-6 py-4 font-medium text-slate-900 whitespace-nowrap dark:text-white">
                                                    {client.username}
                                                </th>
                                                <td class="px-6 py-4">
                                                    {client.id_pdv}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example" className='absolute bottom-4 right-2/4'>
                                <ul className="inline-flex -space-x-px text-sm">
                                    <li>
                                        <a className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-slate-500 bg-white border border-slate-300 rounded-l-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={prePage} >Previous</a>
                                    </li>

                                    {numbers.map((n, i) => {
                                        return <li>
                                            <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={() => changeCurrPage(n)}>{n}</a>
                                        </li>
                                    })}

                                    <li>
                                        <a className="flex items-center justify-center px-3 h-8 leading-tight text-slate-500 bg-white border border-slate-300 rounded-r-lg hover:bg-slate-100 hover:text-slate-700 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white" onClick={nextPage} >Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div className="bg-white rounded-2xl shadow-2xl flex flex-col max-h-[85vh]">
                            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                                <div className="min-w-0">
                                    <h2 className="truncate text-lg font-semibold text-slate-800">
                                        {values._client_name || 'Appareil sans nom'}
                                    </h2>
                                    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs">
                                        {values._pin_code && (
                                            <button
                                                type="button"
                                                onClick={copyPin}
                                                title="Copier le code PIN"
                                                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-mono font-semibold transition ${pinCopied ? 'bg-emerald-100 text-emerald-700' : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100'}`}
                                            >
                                                PIN {values._pin_code}
                                                {pinCopied ? (
                                                    <span className="font-sans text-[10px] font-medium">✓ Copié !</span>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-3.5 w-3.5 opacity-60">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                                                    </svg>
                                                )}
                                            </button>
                                        )}
                                        {values._app_type && (
                                            <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600">{values._app_type}</span>
                                        )}
                                        {values._app_version && (
                                            <span className="rounded-full bg-slate-100 px-2 py-0.5 font-mono text-slate-500">v{values._app_version}</span>
                                        )}
                                        <span className={`rounded-full px-2 py-0.5 font-medium ${values._authorized === 'yes' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                                            {values._authorized === 'yes' ? 'Approuvé' : 'En attente'}
                                        </span>
                                        {/* Télémaintenance : statut + déclencheur de provisionnement à distance */}
                                        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-medium text-white ${telemColor}`}>
                                            <span className="h-1.5 w-1.5 rounded-full bg-white/80"></span>
                                            Télémaintenance : {telemLabel}
                                        </span>
                                        {_provDays !== null && (
                                            <span className="text-slate-400">maj {_provDays === 0 ? "auj." : `il y a ${_provDays} j`}</span>
                                        )}
                                        <button
                                            type="button"
                                            onClick={handleProvision}
                                            title="Déclencher le provisionnement à distance (installe/patch AnyDesk, RustDesk, plugins…)"
                                            className="inline-flex items-center gap-1 rounded-full bg-indigo-600 px-2.5 py-0.5 font-semibold text-white hover:bg-indigo-500"
                                        >
                                            ⚙ Activer la gestion
                                        </button>
                                        {versionGte(values._app_version, '5.3.3') && (
                                            <button
                                                type="button"
                                                onClick={handleRequestLogcat}
                                                title="Récupérer le logcat des 3 dernières minutes (remonté sur n8n)"
                                                className="inline-flex items-center gap-1 rounded-full bg-slate-600 px-2.5 py-0.5 font-semibold text-white hover:bg-slate-500"
                                            >
                                                📄 Récupérer logcat
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <button type="button" onClick={() => onClose()} className="grid h-8 w-8 shrink-0 place-items-center rounded-lg text-lg leading-none text-slate-400 hover:bg-slate-100 hover:text-slate-700">✕</button>
                            </div>
                            <div className="overflow-y-auto px-6 py-5">
                        <form className="space-y-1" id='createArticleForm' onSubmit={handleSubmit} >
                            <h3 className="text-sm font-semibold text-slate-800 border-b border-slate-100 pb-2 mb-3">🪪 Identité &amp; autorisation</h3>
                            <div className="grid md:grid-cols-3 md:gap-6">
                                <div className="w-full mb-4">
                                    <label htmlFor="_client_name" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Nom Client</label>
                                    <input type="text" name="_client_name" id="_client_name" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _client_name: e.target.value })} value={values._client_name} />
                                </div>
                                <div className="w-full mb-4">
                                    <span className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Autorisé</span>
                                    {/* Segmented control (remplace les radios — même valeur envoyée : 'yes'/'no') */}
                                    <div className="inline-flex w-full rounded-lg border border-slate-300 bg-white p-0.5">
                                        <button
                                            type="button"
                                            onClick={() => setValues({ ...values, _authorized: 'yes' })}
                                            className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition ${values._authorized === 'yes' ? 'bg-emerald-500 text-white shadow-sm' : 'text-slate-600 hover:bg-slate-50'}`}
                                        >
                                            ✓ Oui
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setValues({ ...values, _authorized: 'no' })}
                                            className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition ${values._authorized !== 'yes' ? 'bg-slate-700 text-white shadow-sm' : 'text-slate-600 hover:bg-slate-50'}`}
                                        >
                                            Non
                                        </button>
                                    </div>
                                </div>
                                <div className="w-full mb-4">
                                    <label htmlFor="_end_date" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Date de fin</label>
                                    <input type="date" name="_end_date" id="_end_date" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _end_date: e.target.value })} value={dateInputValue(values._end_date)} />
                                </div>
                            </div>
                            {/* --- Diffusion (vidéos par défaut du device) : MASQUÉE pour les apps >= 5.0.0,
                                 qui diffusent via le PROGRAMME (plus via ces 3 vidéos device). Les valeurs
                                 restent dans `values` (inputs contrôlés) -> non détruites à l'enregistrement. --- */}
                            {!versionGte(values._app_version, '5.0.0') && (
                            <div className="mt-4 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
                                <h3 className="mb-3 text-sm font-semibold text-slate-800">🎬 Diffusion — vidéos par défaut</h3>
                                <div className="grid md:grid-cols-3 md:gap-4">
                                    <div className="w-full mb-2">
                                        <label htmlFor="_video_url" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Vidéo 1</label>
                                        <div className="relative">
                                            <input type="text" name="_video_url" id="_video_url" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _video_url: e.target.value })} value={values._video_url} />
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdown1', '_video_url')} >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="_video_url_2" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Vidéo 2</label>
                                        <div className="relative">
                                            <input type="text" name="_video_url_2" id="_video_url_2" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _video_url_2: e.target.value })} value={values._video_url_2} />
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdown1', '_video_url_2')} >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="_video_url_3" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Vidéo 3</label>
                                        <div className="relative">
                                            <input type="text" name="_video_url_3" id="_video_url_3" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _video_url_3: e.target.value })} value={values._video_url_3} />
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdown1', '_video_url_3')} >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}

                            {/* --- Price-Eat : compte, PDV et réglages prix regroupés --- */}
                            <div className="mt-4 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
                                <h3 className="mb-3 text-sm font-semibold text-slate-800">💶 Price-Eat</h3>
                                <div className="grid md:grid-cols-2 md:gap-4 lg:grid-cols-4">
                                    <div className="w-full mb-2">
                                        <label htmlFor="_client_id" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Client ID</label>
                                        <div className="relative">
                                            <input type="text" name="_client_id" id="_client_id" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _client_id: e.target.value })} value={values._client_id} />
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdownPriceEat', '')} >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="_id_pdv" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">ID PDV</label>
                                        <div className="relative">
                                            <input type="text" name="_id_pdv" id="_id_pdv" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _id_pdv: e.target.value })} value={values._id_pdv} />
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdownPriceEat', '')} >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="_video_code" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Display ID / Taille prix</label>
                                        <input type="text" name="_video_code" id="_video_code" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _video_code: e.target.value })} value={values._video_code} />
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="_zoom" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Symbole €</label>
                                        <select id="_zoom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" defaultValue={values._zoom} onChange={e => setValues({ ...values, _zoom: e.target.value })}>
                                            <option value="true">Affiché</option>
                                            <option value="false">Masqué</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4">
                                <h3 className="text-sm font-semibold text-slate-800 border-b border-slate-100 pb-2 mb-3">📟 Call-Eat</h3>
                            </div>

                            <div className="grid md:grid-cols-2 md:gap-6">
                                {/* <div className="relative z-0 w-full mb-6 group">
                                <input type="text" name="_video_code_2" id="_video_code_2" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " onChange={e => setValues({ ...values, _video_code_2: e.target.value })} value={values._video_code_2} />
                                <label htmlFor="_video_code_2" className="peer-focus:font-medium absolute text-base text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Repetition</label>
                            </div> */}
                                <div className="w-full mb-4">
                                    <label htmlFor="_video_code_2" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Role</label>
                                    <select id="_video_code_2" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" value={values._video_code_2} onChange={handleRoleChange}>
                                        <option value="0">Autonome</option>
                                        <option value="1">Serveur</option>
                                        <option value="2">Client</option>
                                        {values._video_code_2 && !["0", "1", "2"].includes(String(values._video_code_2)) && (
                                            <option value={values._video_code_2}>
                                                {values._video_code_2}
                                            </option>
                                        )}
                                    </select>
                                </div>
                                <div className="w-full mb-4">
                                    <label htmlFor="_room_id" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Room ID</label>
                                    <div className="relative">
                                        <input type="text" name="_room_id" id="_room_id" className="w-full rounded-lg border border-slate-300 bg-white pl-3 pr-10 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " onChange={e => setValues({ ...values, _room_id: e.target.value })} value={values._room_id} />
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer" onClick={dropdownVideo('dropdownCallEat', '')} >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="grid md:grid-cols-2 md:gap-6">
                            <div className="relative z-0 w-full mb-6 group">
                                <label htmlFor="_video_code_3" className="peer-focus:font-medium  text-base text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Direction (paysage or portrait) :</label>
                                <select id="_video_code_3" className="bg-slate-50 border border-slate-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-slate-700 dark:border-slate-600 dark:placeholder-slate-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" defaultValue={values._video_code_3} onChange={e => setValues({ ...values, _video_code_3: e.target.value })}>
                                    <option value="paysage">Paysage</option>
                                    <option value="portrait">Portrait</option>
                                </select>
                            </div>
                            <div className='relative z-0 w-full mb-6 group'>
                                    <label className="text-base text-slate-50 dark:text-white">Client Synchro:</label>
                                    <div className="flex items-center mt-2">
                                        <button
                                            type="button" 
                                            onClick={() => setIsSelectorVisible(true)}
                                            className="text-white bg-blue-600 hover:bg-blue-700 px-3 py-1.5 rounded text-sm font-medium"
                                        >
                                            Sélectionner des clients
                                        </button>
                                        <span className="ml-4 text-slate-300 text-sm">
                                            {values._clients_synchro ? `${values._clients_synchro.length} sélectionné(s)` : '0 sélectionné'}
                                        </span>
                                    </div>
                                    {values._clients_synchro && values._clients_synchro.length > 0 && (
                                        <div className="mt-2 text-xs text-slate-400 break-words">
                                            <strong>PINs:</strong> {values._clients_synchro.join(', ')}
                                        </div>
                                    )}
                                </div>
                        </div> */}
                            <div className="mt-4">
                                <h3 className="text-sm font-semibold text-slate-800 border-b border-slate-100 pb-2 mb-3">🖥️ Synchro / Videowall</h3>
                            </div>
                            <div className="grid md:grid-cols-2 md:gap-6">
                                <div className="w-full mb-4">
                                    <label htmlFor="_video_code_3" className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Direction (paysage or portrait)</label>
                                    <select id="_video_code_3" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" defaultValue={values._video_code_3} onChange={e => setValues({ ...values, _video_code_3: e.target.value })}>
                                        <option value="paysage">Paysage</option>
                                        <option value="portrait">Portrait</option>
                                    </select>
                                </div>

                                <div className='w-full mb-4'>
                                    <label className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1 block">Client Synchro (VideoWall)</label>

                                    {/* --- Affichage des relations EXISTANTES --- */}

                                    {/* CAS 1: L'appareil est un SERVEUR */}
                                    {/* {clientPinsForThisServer.length > 0 && (
                                        <div className="mt-2 text-xs text-green-300">
                                            <strong>Ce serveur est lié à:</strong> {clientPinsForThisServer.join(', ')}
                                        </div>
                                    )} */}
                                     {values._video_code_2 === '1' && (
                                        <div className="mt-2 text-xs text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg p-2">
                                            <strong>Clients existants :</strong>
                                            {currentClientLinks.length > 0 ? (
                                                <ul className="list-disc pl-5">
                                                    {currentClientLinks.map(link => (
                                                        <li key={link.id_videowall} className="flex items-center justify-between">
                                                            <span className="text-slate-700">{link.pin_code_client}</span>
                                                            
                                                            {/* **** MODIFICATION ICI **** */}
                                                            {/* Le bouton (X) devient un Popup de confirmation */}
                                                            <Popup
                                                                trigger={
                                                                    <button 
                                                                        type="button" 
                                                                        className="ml-2 text-red-500 hover:text-red-300 font-bold"
                                                                        title="Supprimer cette liaison"
                                                                    >
                                                                        (X)
                                                                    </button>
                                                                }
                                                                modal // Rend le popup modal
                                                                nested // Permet au popup de fonctionner à l'intérieur d'un autre modal
                                                                {...{ overlayStyle: { background: 'rgba(0,0,0,0.5)' } }}
                                                            >
                                                                {close => (
                                                                    <div className="bg-white text-black p-4 rounded-lg shadow-lg max-w-sm mx-auto">
                                                                        <h3 className="text-lg font-bold mb-2">Confirmation</h3>
                                                                        <p className="mb-4">Êtes-vous sûr de vouloir supprimer la liaison avec {link.pin_code_client} ?</p>
                                                                        <div className="flex justify-end gap-4">
                                                                            <button
                                                                                type="button"
                                                                                className="text-slate-700 bg-slate-200 hover:bg-slate-300 focus:ring-4 focus:outline-none focus:ring-slate-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                                                onClick={close} // Bouton Annuler
                                                                            >
                                                                                Annuler
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                                                onClick={() => {
                                                                                    handleRemoveExistingClient(link.id_videowall); // Appelle la logique de suppression
                                                                                    close(); // Ferme le popup
                                                                                }}
                                                                            >
                                                                                Accepter
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Popup>
                                                            {/* **** FIN DE LA MODIFICATION **** */}

                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <span className="text-slate-400 ml-2">Aucun</span>
                                            )}
                                        </div>
                                    )}

                                    {/* CAS 2: L'appareil est un CLIENT */}
                                    {serverForThisClient && (
                                        <div className="mt-2 text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-lg p-2">
                                            <strong>Ce client est lié à:</strong> {serverForThisClient.pin_code_serveur}
                                        </div>
                                    )}

                                    {/* CAS 3: L'appareil n'a aucune liaison */}
                                    {clientPinsForThisServer.length === 0 && !serverForThisClient && (
                                        <div className="mt-2 text-xs text-slate-400">
                                            Aucune liaison existante.
                                        </div>
                                    )}

                                    {/* --- Section pour AJOUTER de nouveaux clients --- */}
                                    {values._video_code_2 === '1' && (
                                        <>
                                            {/* --- Section pour AJOUTER de nouveaux clients --- */}
                                            <div className="flex items-center mt-3">
                                                <button
                                                    type="button"
                                                    onClick={() => setIsSelectorVisible(true)}
                                                    className="rounded-lg bg-indigo-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-600"
                                                >
                                                    Ajouter des clients
                                                </button>
                                                <span className="ml-4 text-slate-500 text-sm">
                                                    {values._clients_synchro ? `${values._clients_synchro.length} nouveau(x) sélectionné(s)` : '0 sélectionné'}
                                                </span>
                                            </div>

                                            {/* Affiche les pins NOUVELLEMENT sélectionnés pour information */}
                                            {values._clients_synchro && values._clients_synchro.length > 0 && (
                                                <div className="mt-2 text-xs text-indigo-600">
                                                    <strong>PINs à ajouter:</strong> {values._clients_synchro.join(', ')}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                           <div className="grid md:grid-cols-2 md:gap-6 mx-6">
                                <h3 className='text-center text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1'>Screenshot </h3>
                                <div className="flex justify-center mt-2">
                                    <div className="mb-[0.125rem] mr-4 inline-block min-h-[1.5rem] pl-[1.5rem]">
                                        <input
                                            className="h-4 w-4 accent-indigo-500 cursor-pointer align-middle"
                                            type="radio"
                                            id="inlineCheckbox3"
                                            value="1"
                                            onChange={e => setValues({ ...values, _limite_notif: e.target.value })}
                                            defaultChecked={values._limite_notif == 1 ? true : false}
                                            name="_limite_notif"
                                        />
                                        <label
                                            className="inline-block text-sm hover:cursor-pointer text-slate-700"
                                            htmlFor="_limite_notif"
                                        >Oui</label>
                                    </div>

                                    <div className="mb-[0.125rem] mr-4 inline-block min-h-[1.5rem] pl-[1.5rem]">
                                        <input
                                            className="h-4 w-4 accent-indigo-500 cursor-pointer align-middle"
                                            type="radio"
                                            id="inlineCheckbox4"
                                            value="0"
                                            onChange={e => setValues({ ...values, _limite_notif: e.target.value })}
                                            defaultChecked={values._limite_notif == 0 ? true : false}
                                            name="_limite_notif" />
                                        <label
                                            className="inline-block text-sm hover:cursor-pointer text-slate-700"
                                            htmlFor="_limite_notif"
                                        >Non</label>
                                    </div>

                                </div>
                            {/* </div>

                            <div className="grid md:grid-cols-1 mx-6"> */}
                                <h3 className='text-center text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1'>Vidéo non utilisée </h3>
                                <div className="flex justify-center mt-2">
                                    <div className="mb-[0.125rem] mr-4 inline-block min-h-[1.5rem] pl-[1.5rem]">
                                        <input
                                            className="h-4 w-4 accent-indigo-500 cursor-pointer align-middle"
                                            type="radio"
                                            id="inlineCheckbox5"
                                            value="1"
                                            onChange={e => setValues({ ...values, _unused_videos: e.target.value })}
                                            defaultChecked={values._unused_videos == 1 ? true : false}
                                            name="_unused_videos"
                                        />
                                        <label
                                            className="inline-block text-sm hover:cursor-pointer text-slate-700"
                                            htmlFor="_unused_videos"
                                        >Oui</label>
                                    </div>

                                    <div className="mb-[0.125rem] mr-4 inline-block min-h-[1.5rem] pl-[1.5rem]">
                                        <input
                                            className="h-4 w-4 accent-indigo-500 cursor-pointer align-middle"
                                            type="radio"
                                            id="inlineCheckbox6"
                                            value="0"
                                            onChange={e => setValues({ ...values, _unused_videos: e.target.value })}
                                            defaultChecked={values._unused_videos == 0 ? true : false}
                                            name="_unused_videos" />
                                        <label
                                            className="inline-block text-sm hover:cursor-pointer text-slate-700"
                                            htmlFor="_unused_videos"
                                        >Non</label>
                                    </div>

                                </div>
                            </div>
                            <div className="grid grid-cols-3 mx-auto my-3 text-center">
                                <Link to={`/imagemanager/${choosenClientBo._pin_code}`}>
                                    <a href="#buttons-with-link">
                                        <button
                                            className="align-middle select-none font-sans font-medium text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-2.5 px-4 rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 focus:ring focus:ring-indigo-200 active:opacity-[0.85]"
                                            type="button">
                                            Dernier Screenshot
                                        </button>
                                    </a>

                                </Link>
                                <Link to={`/programme/${choosenClientBo._pin_code}`}
                                    state={{ clientName: values._client_name }}
                                >
                                    {/* <a href="#buttons-with-link">*/}
                                    <button
                                        className="align-middle select-none font-sans font-medium text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-2.5 px-4 rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 focus:ring focus:ring-indigo-200 active:opacity-[0.85]"
                                        type="button">
                                        Go to Programme
                                    </button>
                                    {/*   </a> */}
                                </Link>

                                {idClientAnnuaire ? (
                                    <Link to={`/annuairealta/${idClientAnnuaire}`} >
                                        <a href="#buttons-with-link">
                                            <button
                                                className="align-middle select-none font-sans font-medium text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-2.5 px-4 rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 focus:ring focus:ring-indigo-200 active:opacity-[0.85]"
                                                type="button">
                                                Afficher dans l'Annuaire
                                            </button>
                                        </a>
                                    </Link>
                                ) : (
                                    <button disabled className="align-middle select-none font-sans font-medium text-center uppercase text-xs py-2.5 px-4 rounded-lg border border-slate-200 bg-white text-slate-400 opacity-70 cursor-not-allowed">Annuaire indisponible</button>
                                )}

                            </div>
                            <div className="grid md:grid-cols-2 gap-3 mt-6">
                                <div className="rounded-lg bg-slate-50 border border-slate-100 px-4 py-2 text-center">
                                    <span className='text-sm text-slate-600'>Code pin: <span className='font-semibold text-slate-800'>{choosenClientBo._pin_code}</span></span>
                                </div>
                                <div className="rounded-lg bg-slate-50 border border-slate-100 px-4 py-2 text-center">
                                    <span className='text-sm text-slate-600'>Température: <span className='font-semibold text-slate-800'>{choosenClientBo._screen_id}°</span></span>
                                </div>
                            </div>

                            <div className='flex justify-between items-center mt-6 pt-4 border-t border-slate-100'>
                                <Popup trigger=
                                    {<button type="button" className="rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                                    position="right center">
                                    <div className="text-sm text-slate-700 mb-2">Est-ce votre dernier mot?</div>
                                    <div className="flex justify-between gap-2">
                                        <button type="button" className="rounded-lg bg-indigo-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-indigo-600" onClick={deleteArticle}> Accepter </button>
                                        <button type="button" className="rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" onClick={close}> Annuler </button>
                                    </div>
                                </Popup>
                                <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                            </div>
                            <div className="py-4 text-center">
                                <p id="error" className='text-red-600'></p>
                            </div>
                        </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative z-50">
                <MultiDeviceSelector
                    isVisible={isSelectorVisible}
                    onClose={() => setIsSelectorVisible(false)}
                    onSubmit={handleCodePins}
                    currentPinCode={choosenClientBo._pin_code}
                />
            </div>
        </>
    )
}

export default ModalModifyTizenbo;